export default __webpack_public_path__ + "static/media/CheckMarkCircle.00f41418.png";